import { Button, Flex, Switch, Table, Typography } from "antd";
import { useLogs } from "../../providers/LogProvider";
import { Loader } from "../../components/Loader";
import { useState } from "react";
import { AddApp } from "../../components/AddApp";
const { Title } = Typography;
export const MyApps = () => {
  const { apps } = useLogs();
  const [visible, setVisible] = useState(null);
  const [showAddApp, setShowAddApp] = useState(false);

  console.log(apps);

  const columns = [
    {
      title: "App Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "App ID",
      dataIndex: "id",
      key: "id",
    },
    {
      title: "App Secret",
      dataIndex: "secret",
      key: "secret",
      render: (text: string, record: any) => {
        return (
          <span>
            <code>
              {record.id === visible ? text : "*".repeat(text.length)}
            </code>
            <Switch
              checked={record.id === visible}
              checkedChildren="Show"
              unCheckedChildren="Hide"
              defaultChecked={record.id === visible}
              onChange={() =>
                setVisible(visible === record.id ? null : record.id)
              }
              style={{ marginLeft: 8 }}
            />
          </span>
        );
      },
    },
  ];

  if (apps === null) {
    return <Loader />;
  }
  return (
    <Flex vertical align="center" justify="center" style={{ marginTop: 20 }}>
      <Title style={{ marginBottom: 20 }} level={4}>
        My Applications
      </Title>
      <Flex justify="flex-start" style={{ width: "100%" }}>
        <Button
          type="primary"
          onClick={() => setShowAddApp(true)}
          style={{ marginBottom: 20 }}
        >
          Create application
        </Button>
      </Flex>
      {showAddApp && <AddApp onCancel={() => setShowAddApp(false)} />}
      <Table
        style={{ width: "100%" }}
        dataSource={apps || []}
        rowKey="id"
        pagination={false}
        columns={columns}
      />
    </Flex>
  );
};
